import { OperatorLight } from '@/models';
import { BuildingType } from '@/models/building-type';
import { cmhService } from '@/services';
import { CmhAddressState } from '@/store/new-connection-cmh/cmh-address/types';
import { RootState } from '@/store/types';
import { GetterTree } from 'vuex';

export const getters: GetterTree<CmhAddressState, RootState> = {
  isConnectMyHomeAvailableForSelectedBuilding(state: CmhAddressState) {
    if (state?.addressPoint?.flatNumber && state?.addressPoint?.commonElectricMeterNumber && state?.addressPoint?.selection === BuildingType.building) {
      return state.addressPoint.flatNumber <= 4 && state.addressPoint.commonElectricMeterNumber <= 1;
    }

    return true;
  },
  isConnectMyHomeActivated: (state: CmhAddressState) => !!(state.addressPoint?.addressPoint?.subCity.connectMyHomeActivated),
  isProximusAvailable: (state: CmhAddressState, getters) =>
    getters.isConnectMyHomeActivated
    && cmhService.isServiceAvailable(state.addressPoint?.addressPoint?.subCity, OperatorLight.proximus)
  ,
  isOrangeAvailable: (state: CmhAddressState, getters) =>
    getters.isConnectMyHomeActivated
    && cmhService.isServiceAvailable(state.addressPoint?.addressPoint?.subCity, OperatorLight.orange)
  ,
  isOnlyProximusAvailable: (state: CmhAddressState, getters) => getters.isProximusAvailable && !getters.isOrangeAvailable,
  isOnlyOrangeAvailable: (state: CmhAddressState, getters) => !getters.isProximusAvailable && getters.isOrangeAvailable,
  isProximusAndOrangeAvailable: (state: CmhAddressState, getters) => getters.isProximusAvailable && getters.isOrangeAvailable,
  isSwdeAvailable: (state: CmhAddressState, getters) =>
    getters.isConnectMyHomeActivated
    && cmhService.isServiceAvailable(state.addressPoint?.addressPoint?.subCity, OperatorLight.swde)
  ,
  isGasManagerOres: (state: CmhAddressState) => cmhService.isGasManagerOres(state?.addressPoint?.addressPoint?.subCity),
  isGasManagerResa: (state: CmhAddressState) => cmhService.isGasManagerResa(state?.addressPoint?.addressPoint?.subCity),
  isGasAvailable: (state: CmhAddressState) => cmhService.isGasManaged(state?.addressPoint?.addressPoint?.subCity),
  isElectricityAvailable: (state: CmhAddressState) => cmhService.isElectricManagerOres(state?.addressPoint?.addressPoint?.subCity)
}
